import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RegisterModel } from '../models/registerModel';
import { AccountService } from '../services/account.service';
import { SettingService } from '../services/setting.service';
import { ResetPassword } from '../models/ResetPassword';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  active = 1;
  interval;
  mobileNumber: string;
  otp: string = "";
  resetpassword: ResetPassword = new ResetPassword();
  token = "";
  isVerified = false;
  resend: boolean;
  resendTimer = 0;


  constructor(public settingService: SettingService, public accountService: AccountService, public router: Router) { }

  ngOnInit() {
      this.settingService.isError = false;
      this.settingService.message = null;
  }
  startTimer() {
    this.interval = setInterval(() => {
      if (this.resendTimer == 1) {
        clearInterval(this.interval);
        this.resend = true;
      }
      this.resendTimer--;
    }, 1000)
  }

  verifyMobileNumber(mobileNumber) {
    this.isVerified = false;
    this.resend = false;
    this.settingService.isError = false;
    this.settingService.message = '';
    this.settingService.loading = true;
    this.accountService.ForgetPassword(mobileNumber).subscribe(() => {
      this.mobileNumber = mobileNumber;
      this.settingService.loading = false;
      this.settingService.isError = false;
      this.resendTimer = 60;  
      this.startTimer();
      this.active = 2;
    },error => {
      this.isVerified = true;
      this.settingService.isError = true;
      this.settingService.message = error.error.message;
      this.settingService.loading = false;
      this.resend = true;
    });
  }


  forgetPasswordVerifyOtp() {
    if (this.otp.length < 6) {
      return;
    }
    this.settingService.loading = true;
    this.settingService.isError = false;
    this.settingService.message = '';
    this.accountService.ForgetPasswordVerifyOtp(this.mobileNumber, this.otp).subscribe(res => {
      this.isVerified = true;
      this.active = 3;
      this.token = res.token;
      this.settingService.isError = false;
      this.settingService.loading = false;
    },error=>{
      if(error.status == 400){
        this.settingService.isError = true;
        this.settingService.message = error.error.message;
        this.settingService.loading = false;
      }
      else{
        this.isVerified = true;
        this.settingService.isError = true;
        this.settingService.message = error.error.message;
        this.settingService.loading = false;
      }
    });
  }
  setPassword() {
    this.settingService.loading = true;
    this.settingService.isError = false;
    this.settingService.message = '';
    this.resetpassword.mobileNumber = this.mobileNumber;
    this.resetpassword.resetToken = this.token;
    this.accountService.SetPassword(this.resetpassword).subscribe(res => {
      this.settingService.loading = false;
      this.settingService.isError = false;
      this.router.navigate(['login']);
    },error => {
      this.settingService.isError = true;
        this.settingService.loading = false;
      this.settingService.message = error.error.message;
    });
  }
  onOtpChange(event) {
    this.otp = event;
  }
}
